// After a deploy, a tab opened before it still points at the old script files.
// When one of those fails to load, reload once to pick up the new version.

const KEY = 'tp.reloadedForVersion';

export function reloadForNewVersion(): void {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 30_000) return; // never loop
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch { /* private mode: reload anyway */ }
  location.reload();
}

export function watchForNewVersion(): void {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    reloadForNewVersion();
  });
}
